import React from 'react';
import styled from 'styled-components';
import StringFormatter from '../utils/StringFormatter';
import PermissionControlledComponent from "./PermissionControlledComponent";
import FeatureControlledComponent from "./FeatureControlledComponent";
const Anchor = (props) => {
    // TODO ADD I18N
    const outputText = StringFormatter(props.text, props.parameters);
    return React.createElement(FeatureControlledComponent, { requireFeature: props.requireFeature },
        React.createElement(PermissionControlledComponent, { requireAllDirectPermissions: props.requireAllDirectPermissions, requireOneDirectPermission: props.requireOneDirectPermission },
            React.createElement(AnchorContent, { ...props }, outputText)));
};
const AnchorContent = styled.a `
  display: ${props => props.isHidden && 'none'};
  font-family: ${props => props.theme.fonts.medium};
  font-size: 14px;
  color: ${props => props.theme.colors.anchorText};

  text-decoration: none;
  cursor: pointer;
`;
export default Anchor;
//# sourceMappingURL=Anchor.js.map